import React, { useState, useEffect, useContext } from 'react'
import { useParams } from 'react-router-dom';
import axios from 'axios'
import { BsEnvelope, BsShieldLock, BsTelephone } from "react-icons/bs";
import { FiEdit, FiLogOut } from 'react-icons/fi';
import { Link } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { MdKeyboardArrowDown } from "react-icons/md";

import Loader from '../../../Loader/Loader';
import { TabContext } from '../../../../contexts/TabContext'
import './FacultyProfile.css'
import { toastConfig } from '../../../../utils/ToastConfig';


import avatar from '../../../../assets/svg/avatar.svg'

const FACULTY_URL = '/faculty'
const FACULTY_VERIFY_URL = '/faculty/verify'

function FacultyProfile() {

    let { id } = useParams();
    const { updateDropdownTab } = useContext(TabContext);
    const [expanded, setExpanded] = useState(false);


    const [faculty, setFaculty] = useState()
    const [isAuthedUser, setIsAuthedUser] = useState(false)

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    async function checkAuth() {
        const facultyToken = localStorage.getItem('faculty_token')
        if (!facultyToken) {
            setIsAuthedUser(false)
            return
        }
        await axios.post(process.env.REACT_APP_DEPT_API + FACULTY_VERIFY_URL, { id, faculty_token: facultyToken }).then((res) => {
            const data = res.data
            if (data && data.status === 'ok') {
                setIsAuthedUser(true)
            } else {
                setIsAuthedUser(false)
            }
        })
    }
    useEffect(() => {
        async function getFaculties() {
            try {
                const response = await axios.get(process.env.REACT_APP_DEPT_API + FACULTY_URL + '/' + id);
                setFaculty(response.data);
                checkAuth()
            } catch (error) {
                console.error(error);
            }
        }
        getFaculties()
        // eslint-disable-next-line
    }, [id])

    const logout = () => {
        const authToken = localStorage.getItem('faculty_token')
        const user_id = localStorage.getItem('user_id')
        if (!authToken || !user_id) {
            toast.error("not logged in", toastConfig)
        } else {
            localStorage.removeItem('faculty_token')
            localStorage.removeItem('user_id')
            localStorage.removeItem('club_token')
            toast.success("successfully logged out", toastConfig)
            checkAuth()
        }
    }

    const facultyData = [
        {
            id: 1,
            section: 'Areas of interest',
            content: faculty && faculty.areas_of_interest
        },
        {
            id: 2,
            section: 'Courses Handled',
            content: faculty && faculty.courses_handled
        },
        {
            id: 3,
            section: 'Work Experience',
            content: faculty && faculty.work_experience
        },
        {
            id: 4,
            section: 'Qualifications',
            content: faculty && faculty.qualifications
        },
        {
            id: 5,
            section: 'Publications',
            content: faculty && faculty.papers_published
        },
        {
            id: 6,
            section: 'Professional Memberships',
            content: faculty && faculty.professional_memberships
        },

    ]

    return (
        <div className='facultyProfile'>
            <ToastContainer
                position="bottom-right"
                autoClose={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                theme="colored"
            />
            <div className='section__container'>
                <div className='section'>
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link onClick={() => updateDropdownTab(2)} to="/people" className='breadcrumb__link'>
                            Faculty
                        </Link>
                        <Link to="" className='breadcrumb__link bold'>
                            {faculty && faculty.name}
                        </Link>
                    </Breadcrumbs>
                </div>
                {isAuthedUser ?
                    <div className='fp-authed-container'>
                        <h1 className='section__header'>Faculty Profile</h1>
                        <div >
                            <Link to='update'>
                                <button className='fp-authed-edit-btn'><FiEdit />Edit Your Profile</button>
                            </Link>
                            <Link to='change-password'>
                                <button className='fp-authed-pass-btn'><BsShieldLock />Change Password</button>
                            </Link>
                            <button onClick={logout} className='fp-authed-logout-btn'>
                                <FiLogOut />Logout</button>
                        </div>
                    </div> :
                    <div className='section'>
                        <h1 className='section__header'>Faculty Profile</h1>
                    </div>
                }
                {faculty ? (
                    <div className='section'>
                        <div className='fp__container'>
                            <div className='fp__header'>
                                {faculty && (
                                    <img src={faculty.photo ? faculty.photo.url : avatar} alt="Faculty" />
                                )}
                                <div className='fp__header_content'>
                                    <h1>{faculty && faculty.name}</h1>
                                    <p>{faculty && faculty.designation}</p>
                                    <p>{faculty && faculty.joining_date ? "Joined on: " : ""}{faculty && faculty.joining_date}</p>
                                    <p>{faculty && faculty.nature_of_association ? "Nature of Association: " : ""}{faculty && faculty.nature_of_association}</p>
                                    <h3 className='fp__header_badge'>KTU id <span>{faculty && faculty.ktu_id}</span></h3>
                                </div>
                            </div>
                            <div className='fp__content'>
                                <div className='fp__contentLeft'>
                                    <div className='fp_section'>
                                        {facultyData.map((fp) => (
                                            <Accordion
                                                key={fp.id}
                                                expanded={expanded === `${fp.id}`}
                                                onChange={handleChange(`${fp.id}`)}
                                                disableGutters={true}
                                                elevation={0}
                                                sx={{
                                                    background: 'transparent',
                                                    padding: 0,
                                                    width: '100%',
                                                    '&:before': {
                                                        display: 'none',
                                                    }
                                                }}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<MdKeyboardArrowDown className='acc__icon' />}
                                                    aria-controls={`panel${fp.id}bh-content`}
                                                    id={`panel${fp.id}bh-header`}
                                                    sx={{
                                                        padding: 0,
                                                    }}
                                                >
                                                    <h2 className='fp_section_h3'>
                                                        {fp.section}
                                                    </h2>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <div className='fp_div'>
                                                        {fp.content.length > 0 ? fp.content.map((con, id) => (
                                                            <li key={id}>{con}</li>
                                                        )) : <p className='no_data'>No data added yet</p>}
                                                    </div>
                                                </AccordionDetails>
                                            </Accordion>
                                        ))}
                                    </div>
                                </div>
                                <div className='fp__contentRight'>
                                    <div className='fp_links_div'>
                                        <h3>Contact Info</h3>
                                        <a className='fp_single_link' href={`tel:${faculty && faculty.contact_no}`}>
                                            {faculty && faculty.contact_no && (<BsTelephone />)}
                                            {faculty && faculty.contact_no}
                                        </a>
                                        <a className='fp_single_link' href={`mailto:${faculty && faculty.email}`}>
                                            {faculty && faculty.email && (<BsEnvelope />)}
                                            {faculty && faculty.email}
                                        </a>
                                    </div>
                                    {faculty && faculty.additional_links.length > 0 && (
                                        <div className='fp_links_div'>
                                            <h3>Additional Links</h3>

                                            {faculty && faculty.additional_links.map((add, id) => (
                                                <a className='fp_additional_link' href={add.link} target='_blank' rel='noreferrer' key={id}>
                                                    {add.title}
                                                </a>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                ) : <Loader color="#AE9142" size={100} />}
            </div>
        </div>
    )
}

export default FacultyProfile